export default "__VITE_ASSET__C6Ec6oyV__"